import {
    ActionTypes,
    doesWorkflowRejectCodeExist,
    getWorkflowRejectCodeMessage
} from '@tassat/common-definitions';
import { IFormValues } from '@tassat/forms/src/AddAcgNumberForm/types';

import Worker from 'Lib/worker/PrimusWorker';

export const submitAddAcgNumberForm = async (
    values: IFormValues,
    opts: {
        onClose: () => void;
        setSubmitError: React.Dispatch<React.SetStateAction<string>>;
        actionType: ActionTypes;
    }
) => {
    const {
        onClose,
        setSubmitError,
        actionType
    } = opts;

    try {
        let response = { data: undefined };

        for (const key in values) {
            if (typeof values[key] === 'string') {
                values[key] = values[key].trim();
            }
        }
        values.ACGNumber = values.ACGNumber?.toUpperCase();

        if (actionType === ActionTypes.add) {
            response = await Worker.getInstance()
                .createAcg(values);
            onClose();
        } else if (actionType === ActionTypes.edit) {
            const { ACGId, ACGName } = values;
            response = await Worker.getInstance()
                .updateAcg({
                    ACGId,
                    ACGName
                });
            onClose();
        }

        if (response.data && response.data.Status === 48) {
            onClose();
        } else if (response.data && response.data.Status === 49) {
            setSubmitError(`Could not add api connection: ${response.data.Reason || 'Something went wrong'}`);
        } else if (response.data && doesWorkflowRejectCodeExist(response.data.Status)) {
            setSubmitError(`Could not add api connection: ${getWorkflowRejectCodeMessage(response.data.Status)}`);
        }
    } catch (error) {
        setSubmitError('Something went wrong');
    }
};